import {
    RECEIVE_COUNTRY_INFO
} from '../../actions/appActions';

const initialState = "not_set"

const countryReducer = (state=initialState, action)=>{
    Object.freeze(state);
    
    switch (action.type) {
        case RECEIVE_COUNTRY_INFO:
            return action.countryInfo;

        default:
            return state;
    }
};

export default countryReducer;